module.exports = __webpack_public_path__ + "static/media/KH.ba63b2e4.png";